import {
  Controller,
  FieldPath,
  FieldValues,
  useFormContext,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RenderErrorInPath } from "shared/components/forms/RenderErrorInPath";
import { Field, Radio, RadioGroup } from "shared/components/Spor";
import { EndsWith } from "shared/utils/objectUtils";

type SeverityRadioProps<T extends FieldValues> = {
  severityFormField: FieldPath<T> & EndsWith<"severity">;
};

export const SeverityRadio = <T extends FieldValues>({
  severityFormField,
}: SeverityRadioProps<T>) => {
  const { control, formState } = useFormContext<T>();
  const { t } = useTranslation();
  return (
    <>
      <Field as="fieldset">
        <Field as="legend">{t("Alvorlighetsgrad")}</Field>
        <Controller
          control={control}
          name={severityFormField}
          render={({ field }) => (
            <RadioGroup
              name="severity"
              value={field.value ?? ""}
              onChange={field.onChange}
            >
              <Radio value="INFO">{t("Informasjon")}</Radio>
              <Radio value="WARNING">{t("Advarsel")}</Radio>
            </RadioGroup>
          )}
        />
      </Field>
      <RenderErrorInPath
        errors={formState.errors}
        errorPath={severityFormField}
      />
    </>
  );
};
